import React from 'react';
import Moment from 'react-moment';
import axios from 'axios';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import { withCookies } from 'react-cookie';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import OpenInNew from '@material-ui/icons/OpenInNew';

const styles = () => ({
  homeworkTile: {
    padding: 10,
    marginBottom: 10,
    backgroundColor: '#fafafa',
    position: 'relative',
    cursor: 'pointer',
  },
  homeworkTileHeading: {
    color: '#797979',
    fontSize: 12,
    textTransform: 'uppercase',
  },
  homeworkTileContent: {
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 1.5,
    color: '#394f5a',
    wordWrap: "break-word",
  },
  homeworkTileFooter: {
    color: '#797979',
    fontSize: 12,
  },
  homeworkTileFooterContent: {
    marginTop: 12,
  },
  homeworkChip: {
    marginLeft: 8,
    marginRight: 8,
    color: '#fff',
    height: 'auto',
    backgroundColor: '#9e9e9e',
    padding: 2,
  },
  homeworkIcon: {
    fill: '#9e9e9e',
    width: 16,
    height: 16,
  },
  homeworkIconWrapperType: {
    position: 'absolute',
    bottom: 4,
    right: 4,
  },
  homeworkCheckbox: {
    color: '#9e9e9e !important',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  chipBox: {
    marginTop: 10,
  },
  feedbackBadge: {
    display: 'inline-block',
    borderRadius: 15,
    backgroundColor: '#ffc107',
    color: '#212121',
    padding: '2px 5px',
    height: 'auto',
  },
});

class HomeworkTile extends React.Component {
  constructor(props) {
    super(props);

    this.onHomeworkChecked = this.onHomeworkChecked.bind(this);
  }

  onHomeworkChecked(event) {
    const {
      enqueueSnackbar,
      data,
    } = this.props;

    event.preventDefault();
    event.stopPropagation();

    data.status.ticked = data.status.ticked === 'yes'
      ? 'no'
      : 'yes';

    axios
      .get(`${window.apiUrl}/homeworkticked/${data.status.id}`)
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          if (this.props.onHomeworkChecked) {
            this.props.onHomeworkChecked();
          }
        }
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
      onDetailsButtonClick,
      dateFormat,
      data,
    } = this.props;
    const subject = data.subject ? data.subject : '';
    const teacher = data.teacher ? data.teacher : '';

    const homeworkTicked = data.status.ticked === 'yes';

    let hasFeedback = false;
    if (data.status.hasOwnProperty('attachments')) {
      for (let i in data.status.attachments) {
        const hasTeacherHomeworkAttachments = (
          data.status.attachments[i].teacher_homework_attachments &&
          data.status.attachments[i].teacher_homework_attachments.length > 0
        );

        if (
          hasTeacherHomeworkAttachments ||
          data.status.attachments[i].teacher_note
        ) {
          hasFeedback = true;
          break;
        };
      }
    }

    return (
      <Paper
        elevation={1}
        onClick={onDetailsButtonClick.bind(this, data)}
        className={`homework-group-tile ${classes.homeworkTile}`}
      >
        {appType === 'student' && (
          <Checkbox
            className={classes.homeworkCheckbox}
            checked={homeworkTicked}
            onClick={this.onHomeworkChecked}
            value="yes"
          />
        )}
        <div className={classes.homeworkTileHeading}>
          {subject && (
            <span>{subject} - </span>
          )}
          {teacher}
        </div>
        <div className={classes.homeworkTileContent}>
          {data.title}
        </div>
        <div className={classes.homeworkTileFooter}>
          <Grid
            justify="space-between"
            container
            spacing={4}
          >
            <Grid item>
              <div className={classes.homeworkTileFooterContent}>
                <Grid container>
                  <Grid item>
                    <b>{t('Issued')}: </b>
                    <Moment format={'dddd ' + dateFormat}>{data.issue_date}</Moment>
                    <br />
                    <b>{t('Due')}: </b>
                    <Moment format={'dddd ' + dateFormat}>{data.due_date}</Moment>
                    {data.status?.mark && (
                      <>
                        <br />
                        <b>{t('Mark')}: </b>
                        <span>{data.status.mark}</span>
                      </>
                    )}
                  </Grid>
                </Grid>
                <div className={classes.chipBox}>
                  {hasFeedback
                    ? (
                      <Chip
                        label={t('Feedback')}
                        className={classes.feedbackBadge}
                      />
                    )
                    : ''}
                </div>
              </div>
            </Grid>
          </Grid>
          <IconButton
            aria-label="Open"
            onClick={onDetailsButtonClick.bind(this, data)}
            className={`open-homework-details-button ${classes.homeworkIconWrapperType}`}
          >
            <OpenInNew className={classes.homeworkIcon} />
          </IconButton>
        </div>
      </Paper>
    );
  }
}
export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(HomeworkTile))));

